import * as React from 'react';

import {Button} from 'shells/button/button';

import {BackboneFileWrapper} from './backbone-file-wrapper';

type Props = {
    files: any;
    isEmailAttachment?: boolean;
};

type State = {
    isExpanded: boolean;
};

export class FileList extends React.Component<Props, State> {
    rerender: any = () => {
        this.forceUpdate();
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            isExpanded: false,
        };
    }

    componentDidMount() {
        this.props.files.on('add remove reset', this.rerender);
    }

    componentWillUnmount() {
        this.props.files.off(null, this.rerender);
    }

    render() {
        const remainingCount = this.props.files.length - 3;
        const message = this.state.isExpanded ? 'Show less' : `Show ${remainingCount} more`;

        return (
            <div>
                <ol>{this.getFileList()}</ol>
                {this.props.files.length > 3 ? (
                    <Button variant='text-primary' onClick={this.toggleList}>
                        {message}
                    </Button>
                ) : undefined}
            </div>
        );
    }

    toggleList = () => {
        this.setState((prevState) => ({isExpanded: !prevState.isExpanded}));
    };

    getFileList() {
        return (
            this.props.files.models
                // @ts-expect-error
                .sort((a, b) => {
                    const aCreatedTime = a.get('createdTime');
                    const bCreatedTime = b.get('createdTime');

                    if (!aCreatedTime) return -1;
                    if (!bCreatedTime) return 1;

                    return bCreatedTime - aCreatedTime;
                })
                // @ts-expect-error
                .filter((file, index) => (this.state.isExpanded ? true : index < 3))
                // @ts-expect-error
                .map((file) => {
                    return (
                        <BackboneFileWrapper
                            file={file}
                            isEmailAttachment={this.props.isEmailAttachment}
                            key={file.id || file.cid}
                        />
                    );
                })
        );
    }
}
